var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  attrs: { "config-module": "700", reset: true },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery,
                    advSearchItemResetCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.toLook }
                        },
                        [_vm._v("查看")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toAdd }
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.orderImportVisible = true
                            }
                          }
                        },
                        [_vm._v("批量导入")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toEdit }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.handleCancelOrder }
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            disabled: !_vm.$checkPermission([
                              "button_OrderManage_delete"
                            ])
                          },
                          on: { click: _vm.handleDelOrder }
                        },
                        [_vm._v("删除")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            disabled: !_vm.$checkPermission([
                              "button_OrderManage_delete"
                            ])
                          },
                          on: { click: _vm.handleBatchDelOrder }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchDelete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleFinishOrder }
                        },
                        [_vm._v("已完成")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.$checkPermission([
                              "button_OrderManage_renew"
                            ])
                          },
                          on: { click: _vm.handleRenewOrder }
                        },
                        [_vm._v("恢复")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.packageImportVisible = true
                            }
                          }
                        },
                        [_vm._v("导入包装")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleShowReportTemplateSelect }
                        },
                        [_vm._v("导出Excel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.containerImportVisible = true
                            }
                          }
                        },
                        [_vm._v("导入箱型")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "print", type: "success" },
                          on: { click: _vm.toPrint }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "700001",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "700001",
                      total: _vm.filter.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize,
                      "page-sizes": [10, 20, 30, 50, 100, 200, 500]
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: _vm.toQuery
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.showDetail
        ? _c("order-detail", {
            ref: "orderDetail",
            on: { backList: _vm.toBackPreView }
          })
        : _vm._e(),
      _c("import-dialog", {
        attrs: {
          title: "批量导入订单",
          action: _vm.URL.order.importPoInfo,
          visible: _vm.orderImportVisible,
          "folder-name": "booking",
          "file-name": "订单导入模板.xlsx"
        },
        on: {
          onClose: function($event) {
            return _vm.importDialogCallback("orderImportVisible")
          }
        }
      }),
      _c("import-dialog", {
        attrs: {
          title: "批量导入包装",
          action: _vm.URL.order.importPoPackage,
          visible: _vm.packageImportVisible,
          "folder-name": "booking",
          "file-name": "包装导入模板.xlsx"
        },
        on: {
          onClose: function($event) {
            return _vm.importDialogCallback("packageImportVisible")
          }
        }
      }),
      _c("template-select-dialog", {
        attrs: {
          visible: _vm.templateSelectVisible,
          "filter-json": _vm.filterJson,
          options: _vm.templateObj
        },
        on: {
          onSubmit: _vm.handleExportExcel,
          onClose: function($event) {
            _vm.templateSelectVisible = false
          }
        }
      }),
      _c("import-dialog", {
        attrs: {
          title: "批量导入箱型",
          action: _vm.URL.order.importPoContainer,
          visible: _vm.containerImportVisible,
          "folder-name": "booking",
          "file-name": "箱型导入模板.xlsx"
        },
        on: {
          onClose: function($event) {
            return _vm.importDialogCallback("containerImportVisible")
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.cancelOrderDialog.visible,
            title: _vm.cancelOrderDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.cancelOrderDialog, "visible", $event)
            }
          }
        },
        [
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(
              _vm._s(
                this.$t("CargoMsg.Cargo_CancelOrderTip7", [
                  this.cancelOrderDialog.keys.length
                ])
              )
            )
          ]),
          _c("cargo-ag-grid", {
            staticStyle: {
              width: "100%",
              "min-height": "150px",
              "margin-top": "20px"
            },
            attrs: {
              "grid-params": _vm.cancelOrderDialog.gridParams,
              "grid-options": _vm.cancelOrderDialog.gridOptions,
              "column-defs": _vm.cancelOrderDialog.columnDefs,
              "row-data": _vm.cancelOrderDialog.rowData,
              "auto-fit-content": false
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.cancelOrderDialog, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.cancelOrderDialog, "gridParams", $event)
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.cancelOrder()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.cancelOrderDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }